// extracted by mini-css-extract-plugin
export default {"wrapper":"product-item_wrapper__oqq9E","container":"product-item_container__k-Lh7"};